var utils = require( './utils' );

var header_utils= ( function( $ ) {

	var $header_utils;

	var  _init = function() {
		$header_utils = $( '#top-bar' );

		_maybe_setup_account_menu();
	};
	
	var _maybe_setup_account_menu = function () {
		var setup = false;

		if ( utils.viewport_size().width >= 992 && ! setup ) {
			setup = true;
			_setup_account_menu();
		}

		$( window ).smartresize( function() {
			if ( utils.viewport_size().width >= 992 && ! setup ) {
				setup = true;
				_setup_account_menu();
			}
		} );
	};

	var _setup_account_menu = function() {
		var $menu = $header_utils.find( 'ul.account-menu-items' );

		if ( $menu.length > 0 ) {
			var $menu_parent = $header_utils.find('.account-dropdown');

			$menu_parent.mouseenter( function() {
				$menu.slideDown();
				$menu.closest( '.account-menu' ).addClass( 'open' );
				$header_utils.addClass( 'open-account-menu' );
			} );

			$menu_parent.mouseleave( function() {
				$menu.slideUp();
				$menu.closest( '.account-menu' ).removeClass( 'open' );
				$header_utils.removeClass( 'open-account-menu' );
			} );
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = header_utils;